import { create } from "zustand";
import { apiLogin, setAuthToken } from "../lib/api";

const read = (k) => {
  try { return localStorage.getItem(k); } catch { return null; }
};

export const useAuthStore = create((set) => ({
  user: null,
  token: null,
  isLoading: false,
  error: null,

  login: async (email, password) => {
    set({ isLoading: true, error: null });
    try {
      const data = await apiLogin(email, password);
      const token = data.access_token;
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(data.user));
      setAuthToken(token);
      set({ token, user: data.user, isLoading: false });
      return data.user;
    } catch (e) {
      set({ error: e?.response?.data?.detail || "Échec de la connexion", isLoading: false });
      throw e;
    }
  },

  loginGuest: async () => {
    return await useAuthStore.getState().login("client@test.com", "test123");
  },

  logout: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setAuthToken(null);
    set({ user: null, token: null });
  },

  loadToken: () => {
    const token = read("token");
    const userStr = read("user");
    if (token && userStr) {
      try {
        setAuthToken(token);
        set({ token, user: JSON.parse(userStr) });
      } catch { /* ignore */ }
    }
  },

  setSession: (token, user) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
    setAuthToken(token);
    set({ token, user });
  },
}));
